module.exports = __webpack_public_path__ + "img/moreIconPro.59c9a9a7.png";